/**
 * @generated SignedSource<<5a9c32a1ff4f249d1666bc93ab756523>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OriginalEstimateCell_OriginalEstimateCellNew$data = {
  readonly id: string;
  readonly issue: {
    readonly timeTrackingField: {
      readonly " $fragmentSpreads": FragmentRefs<"originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef">;
    } | null | undefined;
  } | null | undefined;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentType": "OriginalEstimateCell_OriginalEstimateCellNew";
};
export type OriginalEstimateCell_OriginalEstimateCellNew$key = {
  readonly " $data"?: OriginalEstimateCell_OriginalEstimateCellNew$data;
  readonly " $fragmentSpreads": FragmentRefs<"OriginalEstimateCell_OriginalEstimateCellNew">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "OriginalEstimateCell_OriginalEstimateCellNew",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTimeTrackingField",
          "kind": "LinkedField",
          "name": "timeTrackingField",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraOriginalTimeEstimateField"
};

(node as any).hash = "f32a8180d501ca136d5e15126610a012";

export default node;
